import CommunicationProgramKeyUserSummaryContainer from './CommunicationProgramKeyUserSummaryContainer.js';

export default CommunicationProgramKeyUserSummaryContainer;